import classNames from 'classnames';
export interface HelpButtonProps {
  ariaLabel?: string;
  className?: string;
  id: string;
  onClick: CallableFunction;
}

export const HelpButton: React.FC<HelpButtonProps> = ({
  className = '',
  id,
  onClick,
  children,
  ariaLabel = 'Help-Button',
}) => {
  return (
    <button
      aria-label={ariaLabel}
      className={classNames(className, 'help-button')}
      id={id ?? ''}
      type="button"
      onClick={() => onClick()}
    >
      {children}
    </button>
  );
};
